import api from './api';

// Get all roles (with optional filters/sorting)
export const getRoles = async (params = {}) => {
  const response = await api.get('/api/roles', { params });
  return response.data;
};

// Get role by ID
export const getRoleById = async (id) => {
  const response = await api.get(`/api/roles/${id}`);
  return response.data;
};

// Create new role
export const createRole = async (roleData) => {
  const response = await api.post('/api/roles', roleData);
  return response.data;
};

// Update role
export const updateRole = async (id, roleData) => {
  const response = await api.put(`/api/roles/${id}`, roleData);
  return response.data;
};

// Toggle role status (active/inactive)
export const toggleRoleStatus = async (id) => {
  const response = await api.patch(`/api/roles/${id}/toggle-status`);
  return response.data;
};

// Delete role
export const deleteRole = async (id) => {
  const response = await api.delete(`/api/roles/${id}`);
  return response.data;
};

// Get all permission resources
export const getAllPermissionResources = async (params = {}) => {
  const response = await api.get('/api/roles/permission-resources', { params });
  return response.data;
};

// Add permission to role
export const addPermissionToRole = async (roleId, permissionData) => {
  const response = await api.post(`/api/roles/${roleId}/permissions`, permissionData);
  return response.data;
};

// Remove permission from role
export const removePermissionFromRole = async (roleId, permissionId) => {
  const response = await api.delete(`/api/roles/${roleId}/permissions/${permissionId}`);
  return response.data;
};

// Get role permissions
export const getRolePermissions = async (roleId) => {
  const response = await api.get(`/api/roles/${roleId}/permissions`);
  return response.data;
};

// Update role permissions
export const updateRolePermissions = async (roleId, permissions) => {
  const response = await api.put(`/api/roles/${roleId}/permissions`, { permissions });
  return response.data;
};
